export default "__VITE_ASSET__CNY73Z_0__"